import angular from 'angular';
import communicationBox from './communicationBox';
import './style.scss';

export default angular
  .module('components.communicationBox', [])
  .component('communicationBox', communicationBox).name;
